// extracted by mini-css-extract-plugin
export var measureBox = "_di-0";